/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import srcVirtualAgentSettingsQuery from '@atlassian/jira-relay/src/__generated__/srcVirtualAgentSettingsQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { clientSideOnly } from '@atlassian/jira-common-client-side-only/src/index.tsx';

export const settingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		clientSideOnly(import(/* webpackChunkName: "async-virtual-agent-settings" */ './src')),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: srcVirtualAgentSettingsQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
				},
			},
		},
	}),
});
